module.exports = __webpack_public_path__ + "static/media/spicy-mama-hero-mobile-roc.894df6bc.jpg";